// Client-side image compression + EXIF stripping (canvas re-draw removes metadata).
const MAX_DIM = 1280;
const QUALITY = 0.8;

export function compressImage(file, maxDim = MAX_DIM, quality = QUALITY) {
  return new Promise((resolve, reject) => {
    if (!file.type.match(/image\/(jpeg|png|webp)/)) {
      reject(new Error("Nur JPG, PNG oder WebP erlaubt."));
      return;
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      if (width > maxDim || height > maxDim) {
        if (width >= height) {
          height = Math.round((height * maxDim) / width);
          width = maxDim;
        } else {
          width = Math.round((width * maxDim) / height);
          height = maxDim;
        }
      }
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);
      // Always export as JPEG -> strips EXIF, predictable MIME
      const dataUrl = canvas.toDataURL("image/jpeg", quality);
      resolve(dataUrl);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Bild konnte nicht geladen werden."));
    };
    img.src = url;
  });
}
